import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-522d22ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "suggestions" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dark-blue" }, "Suggestions d'amélioration", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Cette application est perfectible et continuera à évoluer jour après jour, par le recueil de vos remarques et suggestions que nous vous remercions d’adresser directement à l'adresse mail suivante : "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:pauline@360medics.com",
    class: "mail"
  }, "pauline@360medics.com")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}